/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Organisation } from "./Organisation";
import {
  OrganisationFromJSON,
  OrganisationFromJSONTyped,
  OrganisationToJSON,
  OrganisationToJSONTyped,
} from "./Organisation";

/**
 *
 * @export
 * @interface ApiOrganisationsList200Response
 */
export interface ApiOrganisationsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiOrganisationsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiOrganisationsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiOrganisationsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Organisation>}
   * @memberof ApiOrganisationsList200Response
   */
  results: Array<Organisation>;
}

/**
 * Check if a given object implements the ApiOrganisationsList200Response interface.
 */
export function instanceOfApiOrganisationsList200Response(
  value: object
): value is ApiOrganisationsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiOrganisationsList200ResponseFromJSON(
  json: any
): ApiOrganisationsList200Response {
  return ApiOrganisationsList200ResponseFromJSONTyped(json, false);
}

export function ApiOrganisationsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiOrganisationsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(OrganisationFromJSON),
  };
}

export function ApiOrganisationsList200ResponseToJSON(json: any): ApiOrganisationsList200Response {
  return ApiOrganisationsList200ResponseToJSONTyped(json, false);
}

export function ApiOrganisationsList200ResponseToJSONTyped(
  value?: ApiOrganisationsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(OrganisationToJSON),
  };
}
